import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { getCurrencyCodeString, isCurrencyCodeString } from 'pricing-pages-ui-components/currency/types';
import { jsx as _jsx } from "react/jsx-runtime";
export const CurrencyPicker = ({
  availableCurrencies,
  selectedCurrency,
  onChange
}) => {
  // Filter to ensure all currency codes are valid strings (not symbols or UNDEFINED)
  const validCurrencies = availableCurrencies.filter(isCurrencyCodeString);
  const currencyOptions = validCurrencies.map(availableCurrency => ({
    text: `${availableCurrency} (${I18n.currencySymbols[availableCurrency].symbol})`,
    value: availableCurrency
  }));

  // Filter selectedCurrency to ensure it's a string for rendering
  const selectedValue = getCurrencyCodeString(selectedCurrency) || validCurrencies[0] || 'USD';
  return /*#__PURE__*/_jsx(Select, {
    buttonUse: "transparent",
    menuWidth: 200,
    menuHeight: 320,
    options: currencyOptions,
    onChange: onChange,
    defaultValue: selectedValue,
    value: selectedValue,
    "data-selenium-id": "currency-picker"
  });
};